import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Stats from "@/components/sections/Stats";
import Properties from "@/components/sections/Properties";
import Services from "@/components/sections/Services";
import HomeBuyerPackage from "@/components/sections/HomeBuyerPackage";
import Testimonials from "@/components/sections/Testimonials";
import Calculator from "@/components/sections/Calculator";
import EbookDownload from "@/components/sections/EbookDownload";
import Contact from "@/components/sections/Contact";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Stats />
      <About />
      <Properties />
      <Testimonials />
      <Services />
      <HomeBuyerPackage />
      <Calculator />
      <EbookDownload />
      <Contact />
    </main>
  );
}
